import { Preferences } from '@capacitor/preferences';

export const MOBILE_ACCESS_TOKEN_KEY = 'td_mobile_access_token';
export const MOBILE_TOKEN_STORAGE_BACKEND = 'capacitor-preferences';

const normalizeToken = (token) => {
  const normalized = String(token || '').trim();
  return normalized || null;
};

export const getStoredMobileAccessToken = async () => {
  try {
    const result = await Preferences.get({ key: MOBILE_ACCESS_TOKEN_KEY });
    return normalizeToken(result?.value);
  } catch {
    return null;
  }
};

export const saveStoredMobileAccessToken = async (token) => {
  const normalized = normalizeToken(token);
  try {
    if (normalized) {
      await Preferences.set({ key: MOBILE_ACCESS_TOKEN_KEY, value: normalized });
    } else {
      await Preferences.remove({ key: MOBILE_ACCESS_TOKEN_KEY });
    }
  } catch {
    // Native auth falls back to server-side cookie behavior if storage is unavailable.
  }
};

export const clearStoredMobileAccessToken = async () => {
  try {
    await Preferences.remove({ key: MOBILE_ACCESS_TOKEN_KEY });
  } catch {
    // Nothing to clear if native storage is unavailable.
  }
};
